import { createFeature, createReducer, on } from '@ngrx/store';
import { PaymentLinkLandingComponentPaymentLinkActions } from '../../components';
import { GetSessionFromPaymentLinkV1Response } from '@arc/unified-payments-frontend/shared-payment';
import { PaymentLinkActions } from '../actions';

export interface PaymentLinkState {
  getSessionFromPaymentLinkResponse: GetSessionFromPaymentLinkV1Response;
  isStaticPaymentLink: boolean;
}

export const initialState: PaymentLinkState = {
  getSessionFromPaymentLinkResponse: null,
  isStaticPaymentLink: false,
};

export const paymentLinksFeature = createFeature({
  name: 'paymentLinks',
  reducer: createReducer(
    initialState,
    on(
      PaymentLinkLandingComponentPaymentLinkActions.exchangeTokenForSessionSuccess,
      (state, action) => ({
        ...state,
        getSessionFromPaymentLinkResponse: action.response,
      }),
    ),
    on(
      PaymentLinkActions.setPaymentLinkCustomTemplateData,
      (state, action) => ({
        ...state,
        isStaticPaymentLink: true,
        getSessionFromPaymentLinkResponse: {
          ...state.getSessionFromPaymentLinkResponse,
          customTemplateData: {
            templateId: action.templateId,
            templateName: action.templateName,
            amount: 0,
            templateFields: [],
          },
        },
      }),
    ),
  ),
});

export const {
  name,
  reducer,
  selectGetSessionFromPaymentLinkResponse,
  selectIsStaticPaymentLink,
} = paymentLinksFeature;
